export default {"src":"/_next/static/image/public/images/flags/flag_995.9f92f25d400badf5309f1d6db4436745.svg","height":16,"width":24};